import React, { useEffect, useState } from "react";
import { back_icon, notification, notificationW } from "../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";
import useStore from "../../Screen/redux/store/useStore";
import useStoreKv from "../../LocalStore/useStore";
import { MaskIcon } from "../../Screen/MaskIcon";

const Header = () => {
  const kvStore = useStoreKv();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const path = splitLocation[1];

  const rawWallet = kvStore.kv?.walletAmount;
  const totalWallet =
    typeof rawWallet === "number" || typeof rawWallet === "string"
      ? rawWallet
      : 0;
  const { user, notifyCount } = useStore();
  const count =
    typeof notifyCount === "number" || typeof notifyCount === "string"
      ? notifyCount
      : 0;
  const userName = typeof user?.name === "string" ? user.name : "";

  const getHeading = () => {
    if (path === "profile") return "Profile";
    if (path === "links") return "Links";
    if (path === "winning-history") return "Winning History";
    if (path === "refer-friends") return "Refer Friends";
    if (path === "cart") return "Cart";
    if (path === "withdraw") return "Withdraw Money";
    if (path === "wallet") return "Wallet";
    if (path === "recharge-history") return "Recharge History";
    if (path === "daily-result") return "Daily Result";
    if (path === "my-report") return "My Report";
    if (path === "notifications") return "Notification";
    if (path === "winning-report") return "Winning Report";
    if (path === "purchase-report") return "Purchase Report";
    if (path === "price-list") return "KANDHA AGENCY";
    if (path === "recharge") return "Recharge";
    if (splitLocation[2] === "kerala") return "KERALA BOOKING SLOT";
    if (splitLocation[2] === "dear") return "DEAR BOOKING SLOT";
    return "KANDHA AGENCY";
  };

  const isHome = path === "home"; 

  return (
    <div className={isHome ? "header-container-home" : "header-container"}>
      <div className="d-flex ac-jb">

        {isHome ? (
          <div />
        ) : (
          <img
            onClick={() => navigate(-1)}
            className="pointer"
            src={back_icon}
            height={20}
            width={22}
          />
        )}

        <p
          className="f4 fs-xs-20 fs-sm-20 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28"
          style={{ color: isHome ? '#8F0D3D' : 'white' }}
        >
          {getHeading()}
        </p>

        <div
          onClick={() => navigate("/notifications", { state: { fromFooter: true } })}
          className={isHome ? "notification-home" : "notification"}
        >
          {isHome ?  <MaskIcon
            src={isHome ? notification : notificationW}
            width={25}
            height={30}
            alt=""
          /> : <img
            src={path === "home" ? notification : notificationW}
            color="white"
            width={25}
            height={30}
            alt=""
          />}
          {count !== null && count !== 0 && (
            <p className="f2 noti-text">{count}</p>
          )}
        </div>
      </div>

      <div className="d-flex ac-jb my-2">
        <p
          className="f3 fs-xs-15 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-20 text-capitalize"
          style={{ color: isHome ? '#8F0D3D' : 'white' }} 
        >
          {userName}
        </p>
        <p
          className="f3 fs-xs-15 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-20"
          style={{ color: isHome ? '#8F0D3D' : 'white' }}
        >
          ₹ {totalWallet}
        </p>
      </div>
    </div>
  );
};

export default Header;